import { useState } from "react";
import useHttp from "./use_http";

const useFaq = () => {
  const { httpService } = useHttp();

  const [loadings, setLoadings] = useState({
    getFaqList: false,
  });

  const [faqQuery, setFaqQuery] = useState("");

  const [faqList, setFaqList] = useState([]);
  const [filteredFAQ, setFilteredFAQ] = useState([]);

  const getFaqList = async () => {
    try {
      setLoadings({ ...loadings, getFaqList: true });
      const response = await httpService.get("faq");
      setLoadings({ ...loadings, getFaqList: false });
      setFaqList(response.data);
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getFaqList: false });
    }
  };

  const exports = {
    // entity methods
    getFaqList,
    // entity states
    faqList,
    filteredFAQ,
    setFilteredFAQ,
    // controller states
    faqQuery,
    setFaqQuery,
    // loading states
    loadings,
  };
  return exports;
};

export default useFaq;
